import React, { useEffect, useState, useRef } from 'react';
import { Button, Layout, Flex, Typography, Grid } from 'antd';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useRecoilValue } from 'recoil';
import propTypes from 'prop-types';
import { appConfigAtomState } from '../../state/reducerAtoms/app.atom';



// components
import config from '../../config/config';

import AppDrawer from '../../components/drawer';
import SVGIcons from '../../assets/images/icons/svgIcons';
import './index.scss';
import HeaderRightUserInfo from '../../components/headerRightUserInfo';
import AppHeader from '../../components/header';




// ----------------------------------------------------------------------

const PageLayout = (props) => {
  const appState = useRecoilValue(appConfigAtomState);
  const { appName } = config;
  const { Header, Content } = Layout;
  const { Title } = Typography;
  const {
    pageName = "",
    pageTitle = "",
    bodyClassName = "",
    hideHeaderOnScroll = false,
    children = <></>
  } = props;

  const [collapsed, setCollapsed] = useState(false);
  const screenBreakpoint = Grid.useBreakpoint();

  const closeDrawerClick = () => {
    setCollapsed(false);
  };

  const scrollRef = useRef(null);
  const [showHeader, setShowHeader] = useState(true);

  useEffect(() => {

    const el = scrollRef.current;
    const handleScroll = () => {
      if (!el) return;
      const isAtTop = el.scrollTop <= 30;
      setShowHeader(isAtTop);
    };
    if (el) {
      el.addEventListener('scroll', handleScroll);
      handleScroll();
    }
    return () => {
      if (el) {
        el.removeEventListener('scroll', handleScroll);
      }
    };


  }, []);


  return (
    <>
      <Helmet>
        <title> {pageName} | {appName} </title>
      </Helmet>
      <Layout
        key={`${appState?.selectedLang}`}
        style={{ minHeight: '100vh' }}
        className={`app-body ${bodyClassName}`}

      >
        {screenBreakpoint.lg ? null : <AppDrawer drawerSwitch={collapsed} onClose={closeDrawerClick} />}
        <Layout className={`site-layout ${hideHeaderOnScroll ? (showHeader ? 'header-active' : 'header-inactive') : ''}`}>
          <Header className="main-app-header">

            <div className='container'>

              {screenBreakpoint.lg ? <AppHeader /> : <>

                <Flex horizontal="true" justify={'space-between'} align={'center'} gap={'15px'} >
                  <Flex horizontal="true" justify={'space-between'} align={'center'} gap={'15px'} >
                    <Button type="text" style={{ padding: '0', fontSize: '20px' }} onClick={() => setCollapsed(true)}>
                      <SVGIcons.BurgerMenuIcon />
                    </Button>
                    {pageTitle ? <Title level={4} style={{ color: 'var(--white)' }}>{pageTitle}</Title> : <>&nbsp;</>}
                  </Flex>

                  <HeaderRightUserInfo />

                </Flex>

              </>}
            </div>

          </Header>
          <Content
            className="app-main-content-wrapper"
            style={{
              // padding: `${screenBreakpoint.lg ? '24px' : '15px'}`,
              minHeight: 100,
            }}
            key={`${appState?.selectedLang}`}
            ref={scrollRef}
          >
            {children}
            <Outlet />

          </Content>
        </Layout>
      </Layout>

    </>
  );
}
PageLayout.propTypes = {
  pageName: propTypes.string,
  pageTitle: propTypes.string,
  hideHeaderOnScroll: propTypes.bool,
  children: propTypes.any,
  bodyClassName: propTypes.string
}

export default PageLayout;